/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Remove_Team_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to remove team from space. Please try again." |
*
* @param {Spaces_Remove_Team_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_remove_team_error = /** @type {((inputs?: Spaces_Remove_Team_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Remove_Team_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Entfernen des Teams aus dem Speicherplatz. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Failed to remove team from space. Please try again.")
});